module.exports = __webpack_public_path__ + "static/media/fedexicon.434a7144.svg";